import ENV from '../env.json';

export function makeApiUrl(url: string, queryString = '') {
    return ENV.API + url + '?api_key=' + ENV.APIKEY + '&' + queryString;
}

export function responseValidator(response: any) {
    return response.status === 200;
}
